import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageSquare } = FiIcons;

const FloatingCTA = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      className="fixed bottom-8 right-8 z-[60] hidden md:block"
    >
      <Link 
        to="/contact"
        className="flex items-center gap-3 bg-slate-900 text-white px-6 py-4 font-bold shadow-xl shadow-slate-200 hover:bg-black hover:-translate-y-1 transition-all group"
      >
        <SafeIcon icon={FiMessageSquare} className="text-xl" />
        <span>Start a Project</span>
      </Link>
    </motion.div>
  );
};

export default FloatingCTA;